module.exports = __webpack_public_path__ + "static/img/city-mob-red-ar-3.a61ecd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/city-mob-red-ar-3.png
// module id = 1075
// module chunks = 173